module.exports = __webpack_public_path__ + "img/wildwatch-logo.d03c3a33.png";